import React, { useEffect, useState } from 'react';
import api from '../../services/api';
import Table from '../../components/Table';
import moment from 'moment';
import { useSelector } from 'react-redux';

function Mortalities() {
  const [mortalities, setMortalities] = useState([]);
  const [openProgress, setOpenProgress] = useState(false);
  const selectedCycle = useSelector((state) => state.selectedCycle.selectedCycle);

  const columns = [
    {
      title: 'Viveiro',
      field: 'cycle.pond.description',
      editable: 'never',
      hideFilterIcon: true,
    },
    {
      title: 'Data da mortalidade',
      field: 'date',
      editable: 'never',
      type: 'date',
      hideFilterIcon: true,
      render: (rowData) => <p>{moment(rowData.date.substring(0, 10)).format('DD/MM/YYYY')}</p>,
    },
    {
      title: 'Quantidade de animais',
      field: 'qtd_estimated',
      render: (rowData) => <span>{new Intl.NumberFormat('pt-BR').format(rowData.qtd_estimated)}</span>,
      hideFilterIcon: true,
    },
    {
      title: 'Causa da morte',
      field: 'cause',
      hideFilterIcon: true,
    },
  ];

  useEffect(() => {
    async function loadData() {
      try {
        const response = await api.get(`/mortalities/cycle-code/${selectedCycle.id}`);

        if (response.data.length === 0) {
          setOpenProgress(true);
        }
        if (response.data) {
          setMortalities(response.data);
        }
      } catch (err) {

      }
    }
    loadData();
  }, [selectedCycle.id]);

  function setData(newData) {
    const tempData = [];
    mortalities.map((mortality) => (mortality.id === newData.id
      ? tempData.push(newData)
      : tempData.push(mortality)));
    setMortalities(tempData);
  }

  return (
    <Table
      title="Mortalidades"
      route="/mortalities/"
      routeAdd="/mortality/"
      columns={columns}
      data={mortalities}
      setData={setData}
      dataLoaded={openProgress}
    />
  );
}

export default Mortalities;
